import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default (feature) => {
  const { features } = useSelector((s) => s.settings.account);
  return useMemo(() => {
    if (!features?.length) {
      return false;
    }
    return features.some((i) => i.feature_name === feature);
  }, [features, feature]);
};

export const useAnyFeatures = (features = []) => {
  const account = useSelector((s) => s.settings.account);
  return useMemo(() => {
    if (!account.features?.length) return false;
    if (Array.isArray(features))
      return account.features.some((i) => features.includes(i.feature_name));
    return account.features.some((i) => i.feature_name === features);
  }, [features, account.features]);
};
